<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Part">
<p id="rw-p_133887-00001" style="text-align: left;"><a id="pb-rw_1">
</a></p><a id="pb-rw_1">
</a><div class="title-block" id="rw-title-block_133887-00001"><a id="pb-rw_1">
<p class="title-other"><img alt="alt" src="1-1.png"/>
</p>
</a><p class="title-num" style="margin-top: 1em;"><a id="pb-rw_1"></a><a href="#/9781847678164_tableofcontents">PART ONE</a></p>
<h1><a href="#/9781847678164_tableofcontents">[1778–1800]</a></h1>
</div>
<p class="fp" id="rw-p_133887-00003"><a id="pb-rw_2">
</a></p><a id="pb-rw_2">
</a></div><a id="pb-rw_2">
</a></div><a id="pb-rw_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847678164_part_01.vue?d3758fc4